export const apiBaseUrl = `${process.env.REACT_APP_BACKEND_URL}`;
// export const baseUrl = "https://hellonew.arjunglasshouse.com/";
// export const baseUrl = "https://myhello.store/";
// export const baseUrl = "https://myhello.infyedgesolutions.com/";
export const baseUrl = `${window.location.origin}/`;

// export const baseUrl = "http://192.168.1.9:3000/";

// export const baseUrl="http://192.168.57.176/"

export const inactivePathNamesForBreadCrumbs  = [
    "productdetails",
    "collectiondetails"
]
